import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import { DateTime } from 'luxon';
import { SUBSCRIPTION_PRODUCT } from '../../constants';
import { useAuth } from '../../AuthContext';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

function ManageButton({ children, ...rest}) {
  return (
    <Button href="/api/subscriptions/manage" variant="contained" size="small" color="primary" {...rest}>{children}</Button>
  )
}
function CheckoutButton({ children, ...rest}) {
  return (
    <form action="/api/subscriptions/checkout" method="POST">
      {/* Add a hidden field with the lookup_key of your Price */}
      <input type="hidden" name="lookup_key" value={SUBSCRIPTION_PRODUCT} />
      {/* <Button type="submit" variant="outlined" size="small" color="primary">Upgrade to Pro</Button> */}
      <Button type="submit" variant="contained" size="small" color="primary" {...rest}>{children}</Button>
    </form>
  )
}

export default function Billing() {
  const auth = useAuth();
  
  const expireTime = useMemo(() => {
    if (auth.user?.stripe?.expiresAt) {
      return DateTime.fromISO(auth.user.stripe.expiresAt).toLocaleString(DateTime.DATE_FULL);
    }
    return 'Invalid Date';
  }, [auth.user?.stripe?.expiresAt]);

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Billing &amp; Subscriptions
      </Typography>

      <Grid2
        container
        spacing={2}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid2 size={12}>

          <Card>
            <CardHeader title="Subscriptions" subheader="Manage your billing info" />
            <CardContent sx={{ p: 4 }}>
              <Grid2 container={true} spacing={3} sx={{ alignItems: 'center' }}>
                <Grid2 size={3}>
                  <Typography>Current Plan</Typography>
                </Grid2>
                <Grid2 size={9} sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                  {/* <pre>{JSON.stringify(auth.user, null, 1)}</pre> */}

                  {auth.user?.stripe?.activeProSubscription ? (
                    <>
                      <Chip variant="outlined" size="medium" color={'primary'} label="OpenGolfSim Pro" />
                      <Typography variant="body2" color="textSecondary">
                        {auth.user?.stripe?.isCanceled ? 'Cancels' : 'Renews'} {expireTime}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Chip size="medium" label="OpenGolfSim Free" />
                      {/* <form action="/api/subscriptions/checkout" method="POST">
                        <input type="hidden" name="lookup_key" value={SUBSCRIPTION_PRODUCT} />
                        <Button type="submit" variant="outlined" size="small" color="primary">Upgrade to Pro</Button>
                      </form> */}
                    </>
                  )}

                </Grid2>
                <Grid2 size={9} offset={3}>
                {auth.user.stripe?.activeProSubscription ? 
                  <ManageButton>Manage Subscription</ManageButton>
                  : (
                  <CheckoutButton>Upgrade to OpenGolfSim Pro</CheckoutButton>
                 )}
                  </Grid2>
              </Grid2>
            </CardContent>
          </Card>

          
        </Grid2>

      </Grid2>

    </Box>
  );
}